import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { keys } from "./keys";

async function closeSubTopic(id: string) {
  const { error } = await apiClient
    .from('sub_topics')
    .update({
      state: 'closed',
    })
    .eq('id', id)

  if (error) {
    throw error
  }
}

export function useCloseSubTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (subTopicId: string) => closeSubTopic(subTopicId),
    onSuccess: () => {
      enqueueSnackbar('Sujet clôturé.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.subTopicList() });
    }
  })
}
